export default __webpack_public_path__ + "static/media/scrollcard1.e96a84c5.jpg";